import { Link } from '@material-ui/core';

import useCurrentUser from 'hooks/useCurrentUser';

const url = process.env.REACT_APP_HOMEPAGE_ADMIN_URL;

export default function RedirectToAdmin() {
  const currentUser = useCurrentUser();
  const { acessos } = currentUser || {};

  const isAdmin = acessos?.alias === 'admin';
  const isSupervisor = acessos?.alias === 'supervisor';

  if (isAdmin || isSupervisor) {
    return (
      <Link
        href={url}
        target="_blank"
        rel="no-referrer"
        underline="always"
        color="textPrimary"
      >
        Acesso admin
      </Link>
    );
  }

  return null;
}
